import './SocialShare.css';
import TwitterIcon from './icons/TwitterIcon';
import { useEffect, useState } from 'react';
import EmailIcon from './icons/EmailIcon';
import FacebookIcon from './icons/FacebookIcon';
import RedditIcon from './icons/RedditIcon';
import PinterestIcon from './icons/PinterestIcon';

const SocialShare = () => {

    const [currentUrl, setCurrentUrl] = useState('');
    const [pageTitle, setPageTitle] = useState('');

    useEffect(() => {
        const title = document.querySelector('title')?.textContent || '';

        setCurrentUrl(encodeURIComponent(window.location.href))
        setPageTitle(encodeURIComponent(title));
    }, []);

    // `https://twitter.com/intent/tweet/?text=${shareText}&url=${url}`

    return (
        <div className="flex flex-wrap justify-center gap-4 mt-20 mb-20">
            <a
                href={ `https://twitter.com/intent/tweet?url=${ currentUrl }&text=${ pageTitle }` }
                title="Share on Twitter"
                className="share-btn twitter-btn flex items-center justify-center px-6 py-3 rounded-lg text-white whitespace-nowrap"
                target="_blank"
                rel="noopener noreferrer">
                    <TwitterIcon/>
                    <span className="ml-2">Share on Twitter</span>
            </a>

            <a
                href={ `mailto:?subject=${ pageTitle }` }
                title="Send Email"
                className="share-btn email-btn flex items-center justify-center px-6 py-3 rounded-lg text-white whitespace-nowrap"
                target="_blank"
                rel="noopener noreferrer">
                <EmailIcon />
                <span className="ml-2">Send Email</span>
            </a>

            <a
                href={ `https://facebook.com/sharer/sharer.php?u=${ currentUrl }` }
                title="Share on Facebook"
                className="share-btn facebook-btn flex items-center justify-center px-6 py-3 rounded-lg text-white whitespace-nowrap"
                target="_blank"
                rel="noopener noreferrer">
                <FacebookIcon />
                <span className="ml-2">Share on Facebook</span>
            </a>

            <a
                href={ `https://reddit.com/submit/?url=${ currentUrl }` }
                title="Share on Reddit"
                className="share-btn reddit-btn flex items-center justify-center px-6 py-3 rounded-lg text-white whitespace-nowrap"
                target="_blank"
                rel="noopener noreferrer">
                <RedditIcon />
                <span className="ml-2">Share on Reddit</span>
            </a>

            <a
                href={ `https://pinterest.com/pin/create/button/?url=${ currentUrl }` }
                title="Share on Pinterest"
                className="share-btn pinterest-btn flex items-center justify-center px-6 py-3 rounded-lg text-white whitespace-nowrap"
                target="_blank"
                rel="noopener noreferrer">
                <PinterestIcon />
                <span className="ml-2">Share on Pinterest</span>
            </a>

        </div>
    )
};

export default SocialShare;